import { UserRole } from 'context';

/**
 * Кому карьерный центр вообще отвечает в ЛМС (ТЗ 0039 доводка).
 *
 * 🔴 Одно определение на все хуки раздела. Раньше условие `active_role !==
 * STUDENT` стояло семью копиями, и добавление второго зрителя означало семь
 * шансов забыть одну — забытая копия не падает, она молча шлёт запрос,
 * который сервер отбивает, и раздел выглядит поломанным без единой ошибки.
 *
 * Преподавателя здесь НЕТ, хотя он тоже сидит в ЛМС: сервер отказывает ему по
 * тем же полям, и добавить его сюда значит завести на каждой странице пачку
 * молчаливых PermissionDenied.
 */
export const isCareerViewer = (activeRole?: string | null): boolean =>
  activeRole === UserRole.STUDENT || activeRole === UserRole.METHODIST;
